namespace('compass.hotel');

compass.require('compass.arctic.HeaderWidget');
compass.require('compass.hotel.HotelInfoWidget');
compass.require('compass.hotel.BookingGridWidget');
compass.require('compass.hotel.BookingGridHelperWidget');
compass.require('compass.hotel.ReservationManager', { includeCSS : false });
compass.require('compass.hotel.RoomTypesWidget');
compass.require('compass.hotel.ReservationConfirmationWidget');
compass.require('compass.hotel.HotelBookingNavWidget');
compass.require('compass.map.BigMapWidget');
compass.require('compass.map.MapboxWidget');
compass.require('compass.hotel.StaySummaryWidget');
compass.require('compass.hotel.AvailabilityTableWidget');
compass.require('compass.hotel.HotelDescriptionWidget');
compass.require('compass.hotel.HotelImageGalleryWidget');
compass.require('compass.hotel.AvailableRoomListWidget');
compass.require('compass.hotel.AffiliateAvailableRoomListWidget');
compass.require('compass.arctic.TextPopupWidget');
compass.requireLib('compass.util.format');

compass.hotel.HotelBookingWidget = compass.defineWidget(function HotelBookingWidget(options) {
	var me = this;
	var $j = jQuery;

	var _tabList = {
		reservations: {
			navIdentifier: 'Reservations',
			displayName : 'Reservations',
			eventName : 'HotelReservations',
			tabId : compass.generateId(),
			contentId : compass.generateId()
		},
		photos: {
			navIdentifier: 'Photos',
			displayName : 'Photos',
			eventName : 'HotelPhotos',
			tabId : compass.generateId(),
			contentId : compass.generateId()
		},
		map: {
			navIdentifier: 'Map',
			displayName : 'Map',
			eventName : 'HotelMap',
			tabId : compass.generateId(),
			contentId : compass.generateId()
		},
		info: {
			navIdentifier: 'Info',
			displayName : 'Info',
			eventName : 'HotelInfo',
			tabId : compass.generateId(),
			contentId : compass.generateId()
		}
	};
	var _tabCallbacks = { };
	// an object that maps a string (corresponding to tab choices) to a struct representing how to construct a widget

	var _settings = options;
	var _hotelInfoWidget;
	var _hotelBookingNavWidget;
	var _roomTypesWidget;
	var _bookingGridWidget;
	var _bookingGridHelperWidget;
	var _availabilityTableWidget;

	var _checkInDate = _settings.checkInDate;
	var _checkOutDate = _settings.checkOutDate;
	var _requestedRooms = _settings.requestedRooms;

	var _gridHolder;
	
	var _confirmDialog;
	var _reservationManager;
 /* if there is housing reserved already, the reserve button in the booking grid widget should always be enabled */
	var forceReserveButtonEnabled = (_checkInDate && _checkOutDate) ? true : false;

	var _hotelIsGDS = _settings.hotel.avail.status === 'GDS';
	var _maxAllowed = _settings.hotel.avail.maxAllowed;
	var buttonText = _settings.categoryHasOnlyOneHotelAvail == true ? 'Back' : 'Shop Other Hotels';

	var _confirmationDialogId = compass.generateId();

	this.grabValues = function() {

	};

	this.getCurrentSelection = function() {
		if(_bookingGridWidget.hasSelection()) {
			var stays = _bookingGridWidget.grabValues();
			var roomType = _roomTypesWidget.grabValues();

			return {
				blocked_room_id : roomType.roomTypeID,
				stays : stays
			};
		} else {
			return {
				blocked_room_id : undefined,
				stays : [ ]
			};
		}
	};

	var roomTypesRateMapper = function(rt) {
	    var _local_checkInDate = _checkInDate || _settings.meetingInfo.peakNight;
	    var _local_checkOutDate = _checkOutDate || _settings.meetingInfo.DayAfterPeakNight;
	    var selectedDates = _.filter(rt.nights, function(night) {
	    	return (_local_checkInDate <= night.date && night.date < _local_checkOutDate);
	    });
	    var rates = _.map(selectedDates, function(night) { return night.inclusiveRoomPrice; });
	    return _.reduce(rates, function(totalRate, rate) { return totalRate + rate; }, 0) / rates.length;
	};

	// checks the selected dates json data and returns the minimum number of rooms across that date range that can be satisfied in a contiguous stay
	// returns 0 if dates are not passed in
	var roomTypesAvailabilityMapper = function(rt) {
		if(_checkInDate && _checkOutDate) {
			var selectedDates = _.filter(rt.nights, function(night) {
				return (_checkInDate <= night.date && night.date < _checkOutDate);
			});
			return _.min(_.map(selectedDates, function(night) { return night.availCount; }));
		}
		else {
			return 0;
		}
	};

	var setupRoomTypes = function(roomTypes, checkInDate, checkOutDate, requestedRooms) {
		// Sort room types
		_.each(roomTypes, function(rt) {
			rt.currAvail = _.foldl(rt.nights, function(m, n) { return m + Number(n.availCount); }, 0);

			if(_hotelIsGDS){
				rt.limitedAvail = false;
				rt.requestedDatesAvail = true;
			} else if(checkInDate && checkOutDate) {
				var requestedDates = _.filter(rt.nights, function(rn) {
					return (checkInDate <= rn.date && rn.date < checkOutDate);
				});
				// first, make sure that the number of nights requested meets the minium night stay requirement
				// if so, mark the room type as unavailable
				if(requestedDates.length < rt.minNights){
					rt.requestedDatesAvail = false;
				}
				else{
					// the minimum night requirement was met
					// check to make sure every night in the date range is available  and if so change the availability of this room type as true
					rt.requestedDatesAvail = _.every(requestedDates, function(rn) {
						return (rn.availInfo === 'AVAIL');
					});
				}

				// flag the room type as limited availability if across the date range we can't fully satisfy the requested number of rooms
				rt.limitedAvail = roomTypesAvailabilityMapper(rt) < _requestedRooms;
			} else {
				// if there's no dates requested, if this room type has at least one available night, flag the room type as available
				rt.requestedDatesAvail = _.some(rt.nights, function(rn) {
					return (rn.availInfo === 'AVAIL');
				});
				rt.limitedAvail = false;

			}
		});

		_settings.hotel.roomTypes = _(roomTypes).chain()
									.sortBy(function(rtype){return rtype.name;})
									.sortBy(function(rtype){return rtype.occupants;})
									.sortBy(function(rtype){return Number(roomTypesRateMapper(rtype));})
									.sortBy(function(rtype){return (rtype.requestedDatesAvail && !rtype.limitedAvail) ? 0 : 1;}) /* if dates are avail and not limited avail then 0 which will put them first above 1.*/
									.value();
	};

	var getInitialRoomType = function(roomTypes, checkInDate, checkOutDate, requestedRooms) {
		// get initial roomtype
		var _initRoomType;
		if(checkInDate && checkOutDate) {
			var availableRoomTypes = _.filter(roomTypes, function(rt) {	return rt.requestedDatesAvail; });
		  _initRoomType = availableRoomTypes.length ? _.first(availableRoomTypes) : _.first(roomTypes);
		} else {
			_initRoomType = _.max(roomTypes, function(rt) {
				var availableNights = _.filter(rt.nights, function(rn) {
					return ( (rn.requestedDate === 'IN' || rn.requestedDate === 'FIRST' || rn.requestedDate === 'LAST') &&
						(rn.availInfo === 'AVAIL' && rn.availCount >= requestedRooms));
				});
				return availableNights.length;
			});
		}
		return _initRoomType;
	};

	function setupRoomTypesWidget(firstAvailableRoomType,bookingGridWrapper){
		var sortRoomTypes = function() {
			var dates = _bookingGridWidget.grabValues();
			var newCheckInDate = dates.nights.length ? _.first(dates.nights).nightDate : undefined;
			var newCheckOutDate = dates.nights.length ? _.last(dates.nights).nightDate : undefined;

			if(_checkInDate !== newCheckInDate || _checkOutDate !== newCheckOutDate) {
				_checkInDate = newCheckInDate;
				_checkOutDate = newCheckOutDate;
				setupRoomTypes(_settings.hotel.roomTypes, _checkInDate, _checkOutDate, _requestedRooms);
				$('.RoomTypesWidget .dataSelect').trigger('rebuildContent', { choices: _settings.hotel.roomTypes });
			}
		};

		return _roomTypesWidget = new compass.hotel.RoomTypesWidget(bookingGridWrapper, {
			WUID : 'RoomTypes_' + _settings.WUID,
			meetingInfo : _settings.meetingInfo,
			hotel : _settings.hotel,
			initialSelection: firstAvailableRoomType.blockedRoomId,
			requestedRooms: _requestedRooms,
			sortRoomTypes: sortRoomTypes,
			rateMapper: roomTypesRateMapper,
			availabilityMapper: roomTypesAvailabilityMapper,
			checkInDate:_checkInDate,
			checkOutDate:_checkOutDate,
			isGDS : _settings.hotel.avail.status === 'GDS'
		});

	}

	function setupHotelInfoWidget(firstAvailableRoomType){

		var d = _d;
		/* INFORMATION ABOUT THE HOTEL, NAME,DISTANCE,AVERAGE RATE, ETC.*/
		var hotelInfoHolder = d.div({ className : 'hotelInfoHolder',
			role : 'complimentary',
			'ARIA-role' : 'complimentary'
		});
		_hotelInfoWidget = new compass.hotel.HotelInfoWidget(hotelInfoHolder, {
			WUID : 'HotelInfo_' + _settings.WUID,
			hotel : _settings.hotel,
			meetingInfo: _settings.meetingInfo,
			displayHotelStars: _settings.displayHotelStars,
			showZeroRateAsTBD : _hotelIsGDS,
			showPromos : !_hotelIsGDS,
			hideDistance : _settings.hideDistance,
			displayPriceSavings: _settings.displayPriceSavings
		});
	
		return hotelInfoHolder;
		
	}
		
	function setupHotelBookingNavWidget(_tabList){
		var d = _d;
		
		var navHolder = d.div({
			className : 'navHolder',
			role : 'navigation',
			'ARIA-role' : 'navigation',
			'ARIA-label' : 'Hotel Information Tabs'
		});
		_hotelBookingNavWidget = new compass.hotel.HotelBookingNavWidget(navHolder, {
			WUID : me.getWUID(),
			hotel : _settings.hotel,
			tabList : _tabList
		});
		_hotelBookingNavWidget.bind('HotelBookingNavWidget.navigationClicked', function(e, data) {
			if(data.eventName == "HotelMap"){
				var tab = $j(".mapTab");
				if(tab.hasClass('disabled'))return;
				if(!tab.hasClass('mapLoaded'))$j('.mapTab').addClass('disabled');
			}
			_showTab(data.navIdentifier);
			compass.trackPageView(data.eventName);
		});

		return navHolder;
		
	}

	
	function drawBookingGrid(bookingGridWrapper,firstAvailableRoomType,reserveButton){
        var d = _d;
	        
        _roomTypesWidget = setupRoomTypesWidget(firstAvailableRoomType,bookingGridWrapper);
	


		var gridHelperMessage = '';
		var arrowPointsAtRoomType;
		var hideArrow;
		var lockGridHelper;

		if (_hotelIsGDS || !_checkInDate && !_checkOutDate) {
			gridHelperMessage = 'Select your room type to view rates and availability.';
			arrowPointsAtRoomType = true;
			hideArrow = false;
			lockGridHelper = false;
		} else {
			gridHelperMessage = 'Select your room type and dates and edit how many rooms you need each night.';
			hideArrow = true;
			lockGridHelper = true;
		}


		_bookingGridHelperWidget = new compass.hotel.BookingGridHelperWidget(bookingGridWrapper, {
			WUID : 'BookingGridHelperWidget_' + _settings.WUID,
			message : gridHelperMessage,
			arrowPointsAtRoomType : arrowPointsAtRoomType,
			hideArrow: hideArrow,
			groupMax: _settings.hotel.avail.groupMax,
			hotelGroupMax: _settings.hotel.avail.hotelGroupMax,
			lockState: lockGridHelper
		});

		bookingGridWrapper.append(d.div({ className : 'clear' }));
		
		var gridDates = firstAvailableRoomType.nights;
		var gridMinNights = firstAvailableRoomType.minNights;
		var setData = true;

		//check if all dates passed in are available for the initial roomtype
		//handles case where unavailable dates get through hotel gallery or a user hacks the url
		var initRequestedDates = _.filter(gridDates, function(night) {
			return _checkInDate <= night.date && night.date < _checkOutDate;
		});
		var unavailableDates = _.some(initRequestedDates, function(night) {
			return night.availInfo !== 'AVAIL' || night.availCount < _requestedRooms;
		});
		if(unavailableDates) {
			_checkInDate = undefined;
			_checkOutDate = undefined;
		}

		if(_hotelIsGDS){
			_settings.hotel.allowComplexStays = false;
		}

		_bookingGridWidget = new compass.hotel.BookingGridWidget(_gridHolder, {
			WUID : 'BookingGrid_' + _settings.WUID,
			meetingInfo : _settings.meetingInfo,
			maxAllowed : _hotelIsGDS ? 9 : _maxAllowed,
			dates : gridDates,
			minNights : gridMinNights,
			syncNumberOfNights : _hotelIsGDS,
			forceReserveButtonEnabled : forceReserveButtonEnabled,
			allowComplexStays : _settings.hotel.allowComplexStays,
			hideNumberOfRoomsAvailable : _settings.hideNumberOfRoomsAvailable,
			drawRate : !_hotelIsGDS,
			checkInDate : _checkInDate,
			checkOutDate : _checkOutDate,
			requestedRooms : _requestedRooms,
			GINOn : _settings.hotel.GINOn,
			GINThreshold : _settings.hotel.GINThreshold
		});

		_bookingGridWidget.bind('BookingGridWidget.hasNights', function() {
			_bookingGridHelperWidget.setState({
				message: _hotelIsGDS ? 'Select your check-out date.' : 'Select your check-out date, then edit how many rooms you need each night.',
				arrowPointsAtRoomType: false,
				hideArrow: false
			});
		});
		_bookingGridWidget.bind('BookingGridWidget.gridEmpty', function() {
			_bookingGridHelperWidget.setState({
				message: 'Select your room type to view rates and availability.',
				arrowPointsAtRoomType: true,
				hideArrow: false
			});
		});
	}

	function determineFirstAvailableRoomType(){
		        var firstAvailableRoomType;
		        if(_settings.initialBlockedRoomId) {
		            firstAvailableRoomType = _.find(_settings.hotel.roomTypes, function(roomType) {
		                return roomType.blockedRoomId == _settings.initialBlockedRoomId;
		            });
		        } else {
		            firstAvailableRoomType = getInitialRoomType(_settings.hotel.roomTypes, _checkInDate, _checkOutDate, _requestedRooms);
		        }
		        return firstAvailableRoomType;
		        
		    }	


	
	//var bookingGridWrapper = d.div({ className : 'bookingGridWrapper', role : 'form', 'ARIA-role': 'form' });
	this.render = function(widgetElem) {
		var d = _d;

		 var disableButton = function() {
			            return forceReserveButtonEnabled ? '' : ' disabled';
			        };		
		
		setupRoomTypes(_settings.hotel.roomTypes, _checkInDate, _checkOutDate, _requestedRooms);
		var firstAvailableRoomType = determineFirstAvailableRoomType();
		
		_reservationManager = new compass.hotel.ReservationManager(_settings.hotel.nights);
	
	
		widgetElem.bind('BookingGridWidget.addNewRoomsClicked', _addRoomsClicked);
		widgetElem.bind('AvailableRoomListWidget.roomSelected', _handleGDSRoomSelected);
		widgetElem.bind('AffiliateAvailableRoomListWidget.roomSelected', _handleGDSRoomSelected);
		widgetElem.bind('AffiliateAvailableRoomListWidget.viewRoomInfoClicked', _handleGDSRoomInfoClicked);
	
		if(!_hotelIsGDS && ( _settings.hotel.avail.status === 'NORMAL' || _settings.hotel.avail.status === 'SOLDOUT') && _settings.hotel.roomTypes.length > 0) {
			_tabList.availability = {
				navIdentifier: 'Availability',
				displayName : 'Rates & Availability',
				eventName : 'HotelAvailGrid',
				tabId : compass.generateId(),
				contentId : compass.generateId()
			};
		}
	
		if (_settings.hotel.avail.affiliates && _settings.hotel.avail.affiliates.indexOf('EAN') != -1) {
			_tabList.photos.eventName = "ExpediaHotelPhotos";
			_tabList.info.eventName = "ExpediaHotelInfo";
		}
	
		var navHolder = setupHotelBookingNavWidget(_tabList);
		
		var reservationsHolder = d.div({
			className : 'tabContent Reservations',
			id : _tabList.reservations.contentId,
			'aria-labelledby' : _tabList.reservations.tabId
		}, d.reader(d.h3('Reservations')));
	
		var reserveButton = d.button({
			className: 'addNightsButton button' + disableButton(),
			role : 'button',
			tabindex: 0,
			'ARIA-role' : 'button',
			'ARIA-owns' : _confirmationDialogId
		}, 'Next').activate(_addRoomsClicked);
		
		
		reserveButton.attr('aria-disabled', reserveButton.hasClass('disabled') ? 'true' : 'false');

        var bookingGridWrapper = d.div({ className : 'bookingGridWrapper', role : 'form', 'ARIA-role': 'form' });

        _gridHolder = d.div({ className : 'gridHolder' },
                d.reader( d.h4('Choose arrival and departure date and select rooms or shop other hotels to return to gallery') )
            );

        var soldOutDiv = d.div({ className : 'soldOutDiv', style : {padding : 100} },
                d.reader( d.h4('This hotel is sold out or unavailble to your category.') ),
                d.h4('this hotel is sold out or unavailable to your category. click shop other hotels to continue.')
            );
        
        if ( _settings.hotel.roomTypes.length > 0 ){
            drawBookingGrid(bookingGridWrapper,firstAvailableRoomType,reserveButton);
        }

	    bookingGridWrapper.append(_gridHolder);
        
        if ( _settings.hotel.roomTypes.length === 0 ){
            _gridHolder.append(soldOutDiv);
		}

		reservationsHolder.append(bookingGridWrapper);
		
		var shopOtherHotelsButton = d.button({
			className: 'showOthersButton secondaryButton',
			role : 'button',
			tabindex: 0,
			'ARIA-role' : 'button'
		}, buttonText);
		shopOtherHotelsButton.activate( function () { widgetElem.trigger('HotelBookingWidget.shopOtherHotels'); } );

		_gridHolder.append(d.div({ className: 'gridControls' },
			_settings.hotel.roomTypes.length > 0 ? reserveButton : null,
			shopOtherHotelsButton
		));
		
		
		if (_bookingGridWidget){
			_bookingGridWidget.bind('BookingGridWidget.hasNights', function () {
				reserveButton.removeClass('disabled').attr('aria-disabled', 'false');
			});
			_bookingGridWidget.bind('BookingGridWidget.gridEmpty', function () {
				if(!forceReserveButtonEnabled) reserveButton.addClass('disabled').attr('aria-disabled', 'true');
			});
		}

		if(_hotelIsGDS) {
			var checkAvailButton = d.button({ className : 'checkAvail button disabled', 'aria-disabled': 'true', tabindex: 0 }, 'Check Availability');
			checkAvailButton.activate(function(e) {
				if(!checkAvailButton.is('.disabled')) {
					var roomType = _roomTypesWidget.grabValues();
					var stayData = _bookingGridWidget.getBasicData();
					stayData.hotel_id = _settings.hotelId;
					stayData.occupancy = roomType.occupants;
					stayData.country_code = _settings.meetingInfo.officeCountryCode;
					stayData.affiliate = _settings.hotel.avail.affiliates[0];
					stayData.currency = _settings.meetingInfo.currencyCode;
					stayData.handled_by_our_agent = _settings.meetingInfo.affiliateHandledByOurAgent;
					stayData.callback = _displayEPSAvailHandler(stayData, reservationsHolder, stayData.rooms);
					me.trigger('HotelBookingWidget.gdsCheckAvail', stayData);
				}
			});
			bookingGridWrapper.find('.gridControls').prepend(checkAvailButton);

			bookingGridWrapper.find('.gridControls .addNightsButton').hide();
			_bookingGridWidget.bind('BookingGridWidget.selectionChanged', function(e, gridData) {
				if(gridData.hasSelection) {
					checkAvailButton.removeClass('disabled').attr('aria-disabled', 'false');
				} else {
					if(!forceReserveButtonEnabled) checkAvailButton.addClass('disabled').attr('aria-disabled', 'true');
				}
			});
		}

		bookingGridWrapper.find('.gridControls').append(d.div({ className: 'clear' }));

		var staySummaryHolder = d.div({className : 'staySummaryDiv'});
		bookingGridWrapper.append(staySummaryHolder);
		reservationsHolder.append(bookingGridWrapper);

		widgetElem.bind('RoomTypesWidget.roomTypeChanged', function(e, blockedRoomId) {
			var roomType = _.find(_settings.hotel.roomTypes, function(rt) {
				return blockedRoomId == rt.blockedRoomId;
			});

			_bookingGridWidget = new compass.hotel.BookingGridWidget(_gridHolder.empty(), {
				dates: roomType.nights,
				meetingInfo : _settings.meetingInfo,
				minNights : roomType.minNights,
				WUID : 'BookingGrid_' + _settings.WUID,
				maxAllowed : _hotelIsGDS ? 9 : _maxAllowed,
				syncNumberOfNights : _hotelIsGDS,
				forceReserveButtonEnabled : forceReserveButtonEnabled,
				allowComplexStays : _settings.hotel.allowComplexStays,
				hideNumberOfRoomsAvailable : _settings.hideNumberOfRoomsAvailable,
				drawRate : !_hotelIsGDS,
				checkInDate : _checkInDate,
				checkOutDate : _checkOutDate,
				requestedRooms : _requestedRooms,
                GINOn : _settings.hotel.GINOn,
                GINThreshold : _settings.hotel.GINThreshold
			});

			_bookingGridWidget.bind('BookingGridWidget.hasNights', function() {
				_bookingGridHelperWidget.setState({
					message: _hotelIsGDS ? 'Select your check-out date.' : 'Select your check-out date, then edit how many rooms you need each night.',
					arrowPointsAtRoomType: false,
					hideArrow: false
				});
			});
			_bookingGridWidget.bind('BookingGridWidget.gridEmpty', function() {
				_bookingGridHelperWidget.setState({
					message: 'Select your room type to view rates and availability.',
					arrowPointsAtRoomType: true,
					hideArrow: false
				});
			});

			var gridControls = d.div({ className: 'gridControls' });

			if(!_hotelIsGDS) {
				var reserveButton = d.button({
					className: 'addNightsButton button' + disableButton(),
					tabindex: 0
				}, 'Next').activate(_addRoomsClicked);
				reserveButton.attr('aria-disabled', reserveButton.hasClass('disabled') ? 'true' : 'false');

				gridControls.append(reserveButton);
				_bookingGridWidget.bind('BookingGridWidget.hasNights', function () {
				 reserveButton.removeClass('disabled').attr('aria-disabled', 'false');
				});
				_bookingGridWidget.bind('BookingGridWidget.gridEmpty', function () {
					if(!forceReserveButtonEnabled) reserveButton.addClass('disabled').attr('aria-disabled', 'true');
				});
				_bookingGridWidget.refreshReservationButton();
			} else { // hotel is gds
				var setDisabledIfNoDates = (_checkInDate && _checkOutDate) ? '' : ' disabled';
				var checkAvailButton = d.button({ className : 'checkAvail button' + setDisabledIfNoDates, tabindex: 0 }, 'Check Availability');
				checkAvailButton.activate(function(e) {
					if(!checkAvailButton.is('.disabled')) {
						var roomType = _roomTypesWidget.grabValues();
						var stayData = _bookingGridWidget.getBasicData();
						stayData.hotel_id = _settings.hotelId;
						stayData.occupancy = roomType.occupants;
						stayData.country_code = _settings.meetingInfo.officeCountryCode;
						stayData.affiliate = _settings.hotel.avail.affiliates[0];
						stayData.currency = _settings.meetingInfo.currencyCode;
						stayData.handled_by_our_agent = _settings.meetingInfo.affiliateHandledByOurAgent;
						stayData.callback = _displayEPSAvailHandler(stayData, reservationsHolder, stayData.rooms);
						me.trigger('HotelBookingWidget.gdsCheckAvail', stayData);
					}
				});
				checkAvailButton.attr('aria-disabled', checkAvailButton.hasClass('disabled') ? 'true' : 'false');

				gridControls.append(checkAvailButton);
				_bookingGridWidget.bind('BookingGridWidget.hasNights', function () {
					checkAvailButton.removeClass('disabled').attr('aria-disabled', 'false');
				});
				_bookingGridWidget.bind('BookingGridWidget.gridEmpty', function () {
					if(!forceReserveButtonEnabled) checkAvailButton.addClass('disabled').attr('aria-disabled', 'true');
				});
			}

			gridControls.append(
				d.button({
					className: 'showOthersButton secondaryButton',
					tabindex: 0
				}, buttonText).activate( function () { widgetElem.trigger('HotelBookingWidget.shopOtherHotels'); } ),
				d.div({ className: 'clear' })
			);

			_gridHolder.append(gridControls);
		});

		var photosHolder = d.div({
			className : 'tabContent Photos',
			id : _tabList.photos.contentId,
			'aria-labelledby' : _tabList.photos.tabId
		});

		photosHolder.prepend(d.reader(d.h3('Photos')));
		_tabCallbacks['Photos'] = function(){
			params = { hotel_id:_settings.hotelId, show_eps_images: _settings.hotel.hotelInfo.showEPSImages };
			compass.loading.start();
			$j.ajax( {
				url:'/hotelTabImages',
				data: params,
				success:function(data){
					compass.loading.stop();
					var photosWidget = new compass.hotel.HotelImageGalleryWidget(photosHolder.empty(), {
						images: data.images
					});

					jQuery('.hotelImageGalleryDiv').imagesLoaded(function(){
						jQuery('.hotelImageGalleryDiv').masonry({
							itemSelector : '.hotelGalleryImgDiv'
						});
					});
					_tabCallbacks['Photos'] = function(){ return false; };
				},
				complete:function(){ compass.loading.stop(); }

			} );

		};

		var mapHolder = d.div({
			className : 'tabContent Map',
			id : _tabList.map.contentId,
			'aria-labelledby' : _tabList.map.tabId
		}, d.reader(d.h3('Map')));

		if(_settings.meetingInfo.enableMapbox) {
			var mapWidget = new compass.map.MapboxWidget(mapHolder, {
				WUID : 'BigMap_' + _settings.WUID,
				popupUsesHotelCard: false,
				meetingInfo : _settings.meetingInfo,
			});
		} else {
			var mapWidget = new compass.map.BigMapWidget(mapHolder, {
				WUID : 'Mapbox_' + _settings.WUID,
				routeOriginHotel : _settings.hotelId,
				meetingInfo : _settings.meetingInfo,
			});
		}
		_tabCallbacks['Map'] = function() {
			var hotelInfo = _settings.hotel.hotelInfo;
			hotelInfo.avail = _settings.hotel.avail;
			mapWidget.setData([ hotelInfo ]);
			mapWidget.draw();
		};

		var infoHolder = d.div({
			className : 'tabContent Info',
			id : _tabList.info.contentId,
			'aria-labelledby' : _tabList.info.tabId
		}, d.reader(d.h3('Info')));


		_tabCallbacks['Info'] = ( function infoCallback(){
			compass.loading.start();
			$j.ajax( {
				url:'/hotelTabInfo',
				data: {hotel_id: _settings.hotelId},
				success: function(data){
					compass.loading.stop();
	
					if (data.error) {
						var popupParams = {
							title: 'Sorry, there was a problem',
							message: 'Please click OK to try your request again.',
							triggerName: 'stayOnPage'
						};
						var errorMessage = d.div();
						var textPopupWidget = new compass.arctic.TextPopupWidget(errorMessage, popupParams);
						var textPopupWidgetDialog = d.dialog({
							classes: 'errorDialog',
							contents: errorMessage,
							centerOnView: true,
							showCloseButton: false
						});
						textPopupWidget.bind('stayOnPage', function () {
							_showTab('Reservations');
							textPopupWidgetDialog.close();
						});
					}

					data.hotelInfo = _settings.hotel.hotelInfo;
					if (_settings.hotel.avail.affiliates && _settings.hotel.avail.affiliates.indexOf('EAN') != -1){
						data.hotelInfo.EPSHotelInfo = data.EPSHotelInfo;
					}
					var infoWidget = new compass.hotel.HotelDescriptionWidget(infoHolder, {
						WUID : 'HotelDescription_' + _settings.WUID,
						hotelInfo : data,
						defaultPromotions: _settings.hotel.defaultPromotions
					} );
					_tabCallbacks['Info'] = function(){ return false; };
				},
				complete:function(){ compass.loading.stop(); }
			} );
		} );


		var availabilityTableHolder;
		if(!_hotelIsGDS  && ( _settings.hotel.avail.status === 'NORMAL' || _settings.hotel.avail.status === 'SOLDOUT') && _settings.hotel.roomTypes.length > 0 ) {
					availabilityTableHolder = d.div({
						className : 'tabContent Availability',
						id : _tabList.availability.contentId,
						'aria-labelledby' : _tabList.availability.tabId
					}, d.reader(d.h3('Availability')));
					_availabilityTableWidget = new compass.hotel.AvailabilityTableWidget(availabilityTableHolder, {
						WUID : 'AvailabilityTable_' + _settings.WUID,
						hotelInfo : _settings.hotel,
						currencyCode : _settings.meetingInfo.currencyCode,
						maxAllowed: _maxAllowed,
						shortDateFormatter: _settings.meetingInfo.defaultShortDateFormatter
					});
		}

		var contentHolder = d.div({
			className : 'contentHolder',
			role : 'main',
			'ARIA-role' : 'main'
		},
			reservationsHolder,
			photosHolder,
			mapHolder,
			infoHolder,
			availabilityTableHolder
		);

		var hotelInfoHolder = setupHotelInfoWidget(firstAvailableRoomType);
		
		widgetElem.append(
			d.div({ className : 'contentWrapper' },
				hotelInfoHolder,
				d.div({ className : 'mainContent' },
					navHolder,
					contentHolder
				),
				d.div({className:'clear'})
			)
		);

		_showTab('Reservations');

	};

	function _displayEPSAvailHandler(searchData, contentPane, roomsCount) {
		return function(epsAvail) {
			if (epsAvail.GDSSuccess === false && epsAvail.errorText) {
				var popupParams = {
					title: epsAvail.errorTitle,
					message: epsAvail.errorText,
					triggerName: 'stayOnPage'
				};
				var errorMessage = _d.div();
				var textPopupWidget = new compass.arctic.TextPopupWidget(errorMessage, popupParams);
				var textPopupWidgetDialog = _d.dialog({
					classes: 'errorDialog',
					contents: errorMessage,
					centerOnView: true,
					showCloseButton: false
				});
				textPopupWidget.bind('stayOnPage', function () {
					_showTab('Reservations');
					textPopupWidgetDialog.close();
				});
				if (epsAvail.rooms.length === 0) {
					//If this error is because length is zero, we don't want to display the room list at all
					return;
				}
			}
			var bookingGridWrapper = contentPane.find('.bookingGridWrapper');
			$( ".epsResults" ).remove();
			var epsResultsWrapper = _d.div({ className : 'epsResults' });
			var epsResultsWidget = new compass.hotel.AffiliateAvailableRoomListWidget(epsResultsWrapper, {
				searchCriteria: searchData,
				epsAvail: epsAvail,
				meetingInfo: _settings.meetingInfo
			});
			bookingGridWrapper.hide();
			contentPane.append(epsResultsWrapper);
			epsResultsWidget.bind('AffiliateAvailableRoomListWidget.back', function(e) {
				epsResultsWrapper.hide();
				bookingGridWrapper.show();
			});
			epsResultsWidget.bind('AffiliateAvailableRoomListWidget.select', function(e, roomData) {
			});
		};
	}

	function _addRoomsClicked(e) {
		var d = _d;
		var data = _bookingGridWidget.grabValues();
		var roomType = _roomTypesWidget.grabValues();
		var roomTypeData = _.find(_settings.hotel.roomTypes,
				function (rt) { return rt.blockedRoomId === roomType.roomTypeID; });
		var minNights = roomTypeData.minNights;
		var stays = compass._collateStays(data.stays, data.nights);
		// got rid of the !forceReserveButtonEnabled check here for bug 17813. Might break something, possibly bug 12886


		var rdh = compass.util.restrictedDateHelper();
		var noArriveDatesArray = rdh.restrictedDates(roomTypeData.nights, true);
		var noDepartDatesArray = rdh.restrictedDates(roomTypeData.nights, false);
		var violatedRestrictedDates = rdh.violatedRestrictedDates(
			stays,
			noArriveDatesArray,
			noDepartDatesArray
		);
		var errorMessages = rdh.createDateRestrictionErrors(violatedRestrictedDates);

		if (data.nights.length < (minNights + 1)) {
			errorMessages.unshift('Minimum stay of ' + minNights + ' nights is required.');
		}
		else if( _.some(stays, function(stay){return stay.length < minNights;}) ){
			errorMessages.unshift('Minimum stay of ' + minNights + ' nights is required.');
		}

		if (_.any(errorMessages, function(message) { return message.match(/Minimum stay of/)} )) {
			compass.GA.trackEvent('Error', 'View', 'Booking - Min Nt Violation');
		}

		if (_.any(errorMessages, function(message) { return message.match(/Check-(in|out) is not permitted on/)} )) {
			compass.GA.trackEvent('Error', 'View', 'Booking - Arrive/Depart Violation');
		}

		if(errorMessages.length){
			rdh.displayMultiErrorAlert(errorMessages);
			return;
		}

		if (!_.all(data.nights, function(night) {
				if (night.numRooms <= 0) {
					return true;
				}
				return night.numRooms <= _.find(roomTypeData.nights, function(n) {
					return n.date === night.date;
				}).availCount;
			})) {
			d.alert('You have exceeded the maximum number of rooms on one or more nights.');
			return;
		}

		var selection = data;
		data.blocked_room_id = roomType.roomTypeID;
		data.roomType = roomType.roomTypeName;
		var reservations = _reservationManager.getStays();

		if(selection.stays.length > 0 && selection.blocked_room_id && !$j('.addNightsButton').hasClass('disabled')) {
			//disable addNightsButton until reservationConfirmationWidget is closed
			$j('.addNightsButton').addClass('disabled').attr('aria-disabled', 'true');
			me.trigger('HotelBookingWidget.recalculateReservationCost', {
				values : selection,
				callback : function(stayRecap, chargingInfo) {
					var popup = _d.div();

					var numRooms = _.max(selection.nights, function(thisNight) {return thisNight.numRooms;}).numRooms;
					var maxAllowed = _maxAllowed - numRooms;
					var resConfirmData = _.extend({ }, data, {
						WUID : 'ReservationConfirmation_' + _settings.WUID,
						meetingInfo : _settings.meetingInfo,
						stayRecap : stayRecap,
						roomType : roomType,
						canAddMoreRooms : (maxAllowed > 0) && _settings.hotel.allowComplexStays,
						chargingInfo : chargingInfo,
						displayPriceSavings: _settings.displayPriceSavings,
						priceSavingsPercent: _settings.meetingInfo.priceSavingsPercent
					});

					var resConfirmWidget = new compass.hotel.ReservationConfirmationWidget(popup, resConfirmData);

					resConfirmWidget.bind('ReservationConfirmationWidget.AddReservation', function(e, resData) {
						_maxAllowed = maxAllowed;
						_reservationManager.addReservation(resData.stays, data.nights, roomType);
						_bookingGridHelperWidget.hide();
						_bookingGridWidget.clearSelection();
						_bookingGridWidget.forceEnableReserveButton();
						forceReserveButtonEnabled = true;

						_updateAvailability(stayRecap);

						var roomTypeRecap = _reservationManager.getRoomTypeTotals();
						jQuery('.staySummaryDiv').empty();
						var staySummary = new compass.hotel.StaySummaryWidget(jQuery('.staySummaryDiv'), {
							WUID : 'staySummary_' + _settings.WUID,
							roomTypeRecap : roomTypeRecap,
							meetingInfo : _settings.meetingInfo
						});
						_confirmDialog.close();
					});

					resConfirmWidget.bind('ReservationConfirmationWidget.reserveRoomsClicked', function(e, resData) {
						_reservationManager.addReservation(resData.stays, data.nights, roomType);
						var reservations = {
							'reservations' : _reservationManager.getStays(),
							'iterations' : _reservationManager.getIterations()
						};
						me.trigger('HotelBookingWidget.reserveButtonClicked', reservations);
					});

					_confirmDialog = _d.dialog({
						id : _confirmationDialogId,
						centerOnView : true,
						classes : 'confirmationDialog',
						modal : true,
						contents : popup,
						showParent : true,
						onClose : function() {
							$j('.addNightsButton').removeClass('disabled').attr('aria-disabled', 'false');
						}
					});

					_confirmDialog.bind('ReservationConfirmationWidget.closeDialog', function(e) {
						_confirmDialog.close();
	        });
				}
			});
		} else if(!selection.stays.length && reservations.length){
			/*if the user hit 'add more rooms' but then did not maky any changes in the booking grid(!selection.stays.length), AND they already have a reservation (reservations.length) then just move on to the next page */
			me.trigger('HotelBookingWidget.reserveButtonClicked', { "reservations" : reservations });
		}
	}

	function _updateAvailability(stays) {
		_bookingGridWidget.updateAvailability(stays);
		if (_availabilityTableWidget) _availabilityTableWidget.updateAvailability(stays);

		_.each(stays, function(stay) {
			var blockId = _.find(_settings.hotel.roomTypes, function(roomType) {
				return roomType.blockedRoomId == stay.blocked_room_id;
			}).blockId;

			var roomTypes = _.filter(_settings.hotel.roomTypes, function(roomType) {
				return roomType.blockId == blockId;
			});

			_.each(roomTypes, function(roomType) {
				var stayNights = _.filter(roomType.nights, function(night) {
					return night.date >= stay.arrive && night.date < stay.depart;
				});

				_.each(stayNights, function(night) {
					night.availCount = Math.max(0, Number(night.availCount) - stay.rooms);
				});
			});
		});
	}

	var _trackBookingGridHelper = _.once(function() {
		compass.trackEvent('BookingGridHelper');
	});

	function _showTab(name) {
		me.find('.tabContent').hide();
		me.find('.tabContent.' + name).show();
		(_tabCallbacks[name] || function() { })();
	}

	var _d = jQuery.dom.getContext(this);

	function _handleGDSRoomSelected(evt,roomdata){
		var data = roomdata.roomdata;

		var popup = _d.div();

		var affil = data.affiliate;

		var nights = data.nights.slice(0);//clone

		_.each(nights, function(elem){
			elem.fulldate = null;
			elem.nightDate = elem.date;
			elem.numRooms = data.rooms;
		});

		var arrive = nights[0].date;
		var depart = _.last(nights).date;


		var resConfirmData = {
			WUID : 'ReservationConfirmation_' + _settings.WUID,
			gds : true,
			blocked_room_id : -1,
			nights : nights,
			meetingInfo : _settings.meetingInfo,
			stayRecap : [{  arrive: arrive,
				blocked_room_id: -1,
				depart: depart,
				rooms: parseInt(data.rooms),
				GDSInfo : data.GDSInfo,
				summary: {
					additFeeBreakdown: {Surcharges: "0.00", Taxes: "0.00"},
					additFees: data.feesAndTaxes,
					affiliate : affil,
					avgRate: data.avgRate,
					chargedAmount: 0,
					checkIn: arrive,
					checkOut: depart,
					guarantee: data.depositOrGuarantee,
					hotel_id: _settings.hotelId,
					hotelName: _settings.hotel.hotelInfo.name,
					hotelThumbnail: _settings.hotel.images.length > 0 ? _settings.hotel.images[0].link : "",
					numNights: nights.length - 1,
					numRooms: data.rooms,
					occupancy: parseInt(data.occupants),
					roomType: data.name,
					subTotal: data.subTotal,
					totalCost: data.totalCost,
					recap: {}, // Move this outside of the stayRecap array when refactoring to always use the new stay recap widget
				}
			}],
			roomType : {
				roomTypeName: data.name
			},
			stays : [{arrive: arrive,
				depart: depart,
				rooms: parseInt(data.rooms)}],
			canAddMoreRooms : false
		};
		
		if (affil === 'EAN') {
			resConfirmData.stayRecap[0].summary.refundable = data.refundable;
			resConfirmData.stayRecap[0].summary.currencyCode = _settings.meetingInfo.currencyCode;
			for (var index in data.bed_groups) {
				if (data.bed_groups[index].links.price_check.href === data.epsPriceCheckLink) {

					var bedTypeName = '';
					for (var bedTypeIndex in data.bed_groups[index].configuration) {
						if (bedTypeIndex > 0) {
							bedTypeName += " and ";
						}
						bedTypeName += data.bed_groups[index].configuration[bedTypeIndex].bedType;
					}
					resConfirmData.stayRecap[0].summary.bedType = bedTypeName;

				}
			}
			resConfirmData.stayRecap[0].summary.bedRequest =  data.bedRequest;
			resConfirmData.stayRecap[0].summary.depositRequired = data.deposit_required;
			resConfirmData.stayRecap[0].summary.amountDue = data.amount_due;
			resConfirmData.stayRecap[0].summary.dueDateText = data.due_date_text;
			resConfirmData.stayRecap[0].summary.deposits = data.deposits;
			resConfirmData.stayRecap[0].summary.cancelPenalties = data.cancel_penalties;
			resConfirmData.stayRecap[0].summary.nonrefundableRanges = data.nonrefundable_date_ranges;
		}

		function _displayResConfirmWidget() {
			_confirmDialog = _d.dialog({
				centerOnView : true,
				classes : 'HotelBookingWidget confirmationDialog',
				modal : true,
				contents : popup,
				showParent : true,
				disableClicksOutsideModal: true,
			});

			var resConfirmWidget = new compass.hotel.ReservationConfirmationWidget(popup, resConfirmData);

			resConfirmWidget.bind('ReservationConfirmationWidget.closeDialog', function(e) {
				_confirmDialog.close();
			});

			resConfirmWidget.bind('ReservationConfirmationWidget.reserveRoomsClicked', function(e, resData) {
				var roomType = {roomTypeID : -1,
					roomTypeName : data.name };
				_reservationManager.addReservation(resData.stays, nights, roomType);
				var reservations = _reservationManager.getStays();
				_confirmDialog.close();
				me.trigger('HotelBookingWidget.reserveButtonClicked',
					{ "reservations" : reservations });
			});
		}

		//If EPS/EAN hotel - perform a priceCheck and pass data to stayRecapWidget
		if(affil === "EAN") {
			var spinnerDiv = _d.div();
			compass.loading.start(spinnerDiv);
			var _loadingDialog = _d.dialog({
				width : 0,
				centerOnView : true,
				classes : 'HotelBookingWidget loadingDialog',
				contents: spinnerDiv,
				showCloseButton: false,
				disableClicksOutsideModal : true
			});

			resConfirmData.stayRecap[0].GDSInfo.epsPaymentOptions = data.links.payment_options;
			resConfirmData.stayRecap[0].summary.merchant_of_record = data.merchant_of_record;
			resConfirmData.stayRecap[0].summary.is_fenced_deal = data.sale_scenario.member;
			resConfirmData.stayRecap[0].summary.is_distribution_rate = data.sale_scenario.distribution;
			resConfirmData.stayRecap[0].summary.is_corporate_rate = data.sale_scenario.corporate;
			jQuery.ajax({
				url : '/epsPriceCheck',
				data : JSON.stringify({
					hotel_id: _settings.hotelId,
					href: data.epsPriceCheckLink,
					arrive: arrive,
					deposits: data.deposits,
					refundable: data.refundable,
					depart: depart,
					occupancy: parseInt(data.occupants),
					exclusive_total: data.subTotal,
					inclusive_total: data.totalCost,
					merchant_of_record: data.merchant_of_record,
					continent: _settings.hotel.hotelInfo.address.continent
				}),
				type : 'POST',
				contentType : 'application/json',
				success : function(response) {

					var popupParams;

					switch(response.status) {
					  case 'available':
					  case 'price_changed':
							//No error, do nothing
					    break;
					  case 'sold_out':
							popupParams = {
								title: 'Sold Out',
								message: 'That room is no longer available on those dates. Please click OK to shop other rooms.',
								triggerName: 'returnToDates'
							};
					    break;
					  default:
							popupParams = {
								title: 'Sorry, there was a problem',
								message: 'Please click OK to try your search again.',
								triggerName: 'returnToDates'
							};
					}

					// Upon error response, create a popup widget and populate with the relevant text
					if (popupParams !== undefined) {
						var _popupDialog;
						var errorMessage = _d.div();

						var textPopupWidget = new compass.arctic.TextPopupWidget(errorMessage, popupParams);
						textPopupWidget.bind('returnToDates', function () {
							$('.epsResults').hide();
							$('.bookingGridWrapper').show();
							_popupDialog.close();
						});

						_popupDialog = _d.dialog({
							width : 0,
							centerOnView : true,
							classes : 'HotelBookingWidget loadingDialog',
							contents: errorMessage,
							showCloseButton: false,
							disableClicksOutsideModal : true
						});
						$(".closeButtonDefault").css('display','none');
					} else {
						resConfirmData.nights = response.nights;
						resConfirmData.stayRecap[0].summary.avgRate = response.avgRate;
						resConfirmData.stayRecap[0].summary.recap = response.recap;
						resConfirmData.stayRecap[0].summary.status = response.status;
						resConfirmData.stayRecap[0].summary.links = response.links;
						resConfirmData.stayRecap[0].summary.recap_totals = response.recap_totals;
						_displayResConfirmWidget();
						$(".closeButtonDefault").css('display','');
					}
				},
				error: function(res) {
					// Placeholder error text for now -TJD
					_d.alert('Oops! We were unable to find that room type. Please try again.');
					$(".closeButtonDefault").css('display','');
				},
				complete: function() {
					compass.loading.stop();
					_loadingDialog.close();
				}
			});
		} else {
			_displayResConfirmWidget();
		}
	}
	
	function _handleGDSRoomInfoClicked(evt, roomdata) {
		var spinnerDiv = _d.div();
		compass.loading.start(spinnerDiv);
		compass.trackPageView('roominfo');
		var _loadingDialog = _d.dialog({
			width : 0,
			centerOnView : true,
			classes : 'HotelBookingWidget loadingDialog',
			contents: spinnerDiv,
			showCloseButton: false,
			disableClicksOutsideModal : true
		});

		jQuery.ajax({
			url : '/getGDSRoomInfo',
			type : 'GET',
			data : {
				hotel_id: _settings.hotelId,
				eps_room_id: roomdata.roomdata.room_id
			},
			contentType : 'application/json',
			success : function(response) {
				var _detailsColumn;
				if (response.details !== undefined) {
					_detailsColumn = _d.div({className: 'column'},
						_d.div({className: 'header'}, 'Room Details'),
						response.details
					);
				}
		
				var _amenitiesColunn;
				if (response.amenities !== undefined) {
					_amenitiesList = _d.ul({});
					_.each(response.amenities, function(amenity) {
						_amenitiesList.append(_d.li({}, amenity));
					});
					_amenitiesColunn = _d.div({className: 'column'},
						_d.div({className: 'header'}, 'Amenities'),
						_amenitiesList
					);
				}
		
				var _contents = _d.div({className: 'content'},
					_d.h3({}, response.name),
					_d.div({className: 'columns'},
						_detailsColumn,
						_amenitiesColunn
					)
				);
		
				var _roomPoliciesDialog = _d.dialog({
					width : 0,
					centerOnView : true,
					classes : 'HotelBookingWidget gdsRoomInfoDialog',
					contents: _contents,
					showCloseButton: true,
					disableClicksOutsideModal : true
				});
			},
			complete: function() {
				compass.loading.stop();
				_loadingDialog.close();
			}
		});
	}

}, {
	WUID : 'CRAP',
	widgetName : 'HotelBookingWidget',
	hotel : {},
	roomTypes : [],
	maxAllowed : 99999,
	displayHotelStars : true,
	checkInDate : undefined,
	checkOutDate : undefined,
	requestedRooms : 1,
	initialBlockedRoomId : '',
	displayPriceSavings: false
});

